import { render, staticRenderFns } from "./clearCache.vue?vue&type=template&id=4c6debfc&scoped=true&"
import script from "./clearCache.vue?vue&type=script&lang=js&"
export * from "./clearCache.vue?vue&type=script&lang=js&"
import style0 from "./clearCache.vue?vue&type=style&index=0&id=4c6debfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6debfc",
  null
  
)

export default component.exports